// Angular Files
import { NgModule } from '@angular/core';

// Teller Online Component Files
import { CartSummaryTotalsModule } from './cart-summary-totals/cart-summary-totals.component';
import { ChangePhoneModalModule } from './change-phone-modal/change-phone-modal.component';
import { EmailVerifyModule } from './email-verify/email-verify.component';
import { PhoneVerifyModule } from './phone-verify/phone-verify.component';
import { SelectPaymentModule } from './select-payment/select-payment.module';
import { CodeVerificationModule } from './code-verification/code-verification.component';
import { PasswordCaptionModule } from './password-caption/password-caption.component';
import { SearchResultModule } from './search-result/search-result.component';
import { PasswordChangeModule } from './password-change/password-change.component';
import { SeparatedSearchResultModule } from './separated-search-result/separated-search-result.component';
import { PaymentMethodDisplayModule } from './payment-method-display/payment-method-display.module';
import { ScheduleDetailsModalModule } from './schedule-details-modal/schedule-details-modal.module';
import { AuthorizationConsentModule } from './authorization-consent/authorization-consent.component';
import { PaymentConsentDialogModule } from './payment-consent-dialog/payment-consent-dialog.module';
import { CodeInputModule } from './code-input/code-input.component';
import { FullPageDialogContainerModule } from './full-page-dialog-container/full-page-dialog-container.module';
import { FullPageDialogHeaderModule } from './full-page-dialog-header/full-page-dialog-header.module';

@NgModule({
    imports: [
        FullPageDialogHeaderModule,
        FullPageDialogContainerModule,
        CodeInputModule,
        CartSummaryTotalsModule,
        PasswordCaptionModule,
        CodeVerificationModule,
        EmailVerifyModule,
        ChangePhoneModalModule,
        PhoneVerifyModule,
        SelectPaymentModule,
        SearchResultModule,
        SeparatedSearchResultModule,
        PasswordChangeModule,
        PaymentMethodDisplayModule,
        ScheduleDetailsModalModule,
        AuthorizationConsentModule,
        PaymentConsentDialogModule,
    ],
    exports: [
        FullPageDialogHeaderModule,
        FullPageDialogContainerModule,
        CodeInputModule,
        CartSummaryTotalsModule,
        PasswordCaptionModule,
        CodeVerificationModule,
        EmailVerifyModule,
        ChangePhoneModalModule,
        PhoneVerifyModule,
        SelectPaymentModule,
        SearchResultModule,
        SeparatedSearchResultModule,
        PasswordChangeModule,
        PaymentMethodDisplayModule,
        ScheduleDetailsModalModule,
        AuthorizationConsentModule,
        PaymentConsentDialogModule,
    ]
})
export class ComponentsModule { }
